import React from 'react'
import { withTranslation, Trans } from 'react-i18next'

import img1 from '../../images/png/home/whoCan/image1.png'
import img2 from '../../images/png/home/whoCan/image2.png'
import img3 from '../../images/png/home/whoCan/image3.png'
import img4 from '../../images/png/home/whoCan/image4.png'

const WhoCanBlock = ({ t }) => {
    return (
        <div className="home__who-can-block">
            <h3 className="dark">
                <Trans i18nKey={'_pages._home._who_can_block.title'} />
            </h3>
            <ul className="list">
                <li className="item">
                    <img src={img1} alt="" />
                    <div className="text">
                        <div className="title">{t('_pages._home._who_can_block._list._1.title')}</div>
                        <p>{t('_pages._home._who_can_block._list._1.article')}</p>
                        {/*<div className="link">*/}
                        {/*    <Link to="#">{t('_common.learn_more')}</Link>*/}
                        {/*</div>*/}
                    </div>
                </li>
                <li className="item">
                    <img src={img2} alt="" />
                    <div className="text">
                        <div className="title">{t('_pages._home._who_can_block._list._2.title')}</div>
                        <p>{t('_pages._home._who_can_block._list._2.article')}</p>
                        {/*<div className="link">*/}
                        {/*    <Link to="#">{t('_common.learn_more')}</Link>*/}
                        {/*</div>*/}
                    </div>
                </li>
                <li className="item">
                    <img src={img3} alt="" />
                    <div className="text">
                        <div className="title">{t('_pages._home._who_can_block._list._3.title')}</div>
                        <p>{t('_pages._home._who_can_block._list._3.article')}</p>
                        {/*<div className="link">*/}
                        {/*    <Link to="#">{t('_common.learn_more')}</Link>*/}
                        {/*</div>*/}
                    </div>
                </li>
                <li className="item">
                    <img src={img4} alt="" />
                    <div className="text">
                        <div className="title">{t('_pages._home._who_can_block._list._4.title')}</div>
                        <p>{t('_pages._home._who_can_block._list._4.article')}</p>
                        {/*<div className="link">*/}
                        {/*    <Link to="#">{t('_common.learn_more')}</Link>*/}
                        {/*</div>*/}
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default withTranslation('translations')(WhoCanBlock)
